import React from 'react';
import PropTypes from 'prop-types';
import JsonInputPanel from './JsonInputPanel';

const DataSourceToggle = ({
  mode,
  onModeChange,
  extractionJobs,
  selectedExtractionJobId,
  onExtractionJobChange,
  jsonInput,
  onJsonInputChange,
  jsonError,
  loading,
  disabled,
}) => {
  return (
    <div>
      <div
        className="btn-group mb-3"
        role="group"
        aria-label="Data source selection"
      >
        <button
          type="button"
          className={`btn ${mode === 'extraction-job' ? 'btn-primary' : 'btn-outline-primary'}`}
          onClick={() => onModeChange('extraction-job')}
          disabled={disabled}
        >
          Extraction Job
        </button>
        <button
          type="button"
          className={`btn ${mode === 'paste-json' ? 'btn-primary' : 'btn-outline-primary'}`}
          onClick={() => onModeChange('paste-json')}
          disabled={disabled}
        >
          Paste JSON
        </button>
      </div>

      {mode === 'extraction-job' && (
        <div>
          <label htmlFor="extractionJobSelector" className="form-label">
            <strong>Extraction Job</strong> <span className="text-danger">*</span>
          </label>
          <select
            id="extractionJobSelector"
            className="form-select"
            value={selectedExtractionJobId}
            onChange={(e) => onExtractionJobChange(e.target.value)}
            disabled={disabled || loading}
          >
            <option value="">Select an extraction job to test against</option>
            {extractionJobs.map((job) => (
              <option key={job.id} value={job.id}>
                {job.fileName} - {job.status} - {new Date(job.completedAt).toLocaleString()}
                {job.extractionRulesetTypeName && ` (${job.extractionRulesetTypeName})`}
              </option>
            ))}
          </select>
          <small className="form-text text-muted">
            Select a completed extraction job to use as test data
          </small>
        </div>
      )}

      {mode === 'paste-json' && (
        <JsonInputPanel
          value={jsonInput}
          onChange={onJsonInputChange}
          error={jsonError}
          disabled={disabled}
        />
      )}
    </div>
  );
};

DataSourceToggle.propTypes = {
  mode: PropTypes.oneOf(['extraction-job', 'paste-json']).isRequired,
  onModeChange: PropTypes.func.isRequired,
  extractionJobs: PropTypes.array.isRequired,
  selectedExtractionJobId: PropTypes.string,
  onExtractionJobChange: PropTypes.func.isRequired,
  jsonInput: PropTypes.string,
  onJsonInputChange: PropTypes.func.isRequired,
  jsonError: PropTypes.string,
  loading: PropTypes.bool,
  disabled: PropTypes.bool,
};

export default DataSourceToggle;
